//import { NavLink } from "react-bootstrap";
import * as bootstrap from 'bootstrap';
import { NavLink, Link, useLocation } from "react-router-dom";
//import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const MainSidebar = () => {
  const location = useLocation();

  const isProductsActive = location.pathname.startsWith("/listings") || location.pathname.startsWith("/stock");

  useEffect(() => {
      const sidebar = document.getElementById("offcanvasNavbar");
      if (sidebar && sidebar.classList.contains("show")) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(sidebar);
        if (bsOffcanvas) bsOffcanvas.hide();
      }
    }, [location.pathname]);

  return (
    <div className="main-sidebar offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <a className="navbar-brand" href="#">
              <img src="/logo.png" alt="Logo" width="30" height="32" className="d-inline-block align-text-top me-2"/>Profitpalms Analytics</a>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="offcanvas-body ">
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              <li className="nav-item">
                <NavLink
                    to="/"
                    className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                >
                   <i className="fas fa-tachometer-alt"></i> Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                    to="/summary-dashboard"
                    className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
                > 
                   <i className="fas fa-compass"></i> Summary Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link collapse-toggle collapsed" href="#menuCollapseProducts" role="button" data-bs-toggle="collapse" aria-expanded={isProductsActive ? "true" : "false"} aria-controls="menuCollapseProducts">
                  <i className="fas fa-store"></i> Products <i className="fas fa-angle-right"></i>
                </a>
                <div className={isProductsActive ? "collapse show" : "collapse"} id="menuCollapseProducts">
                  <ul className="dropdown-menu show">
                    <li><NavLink  to="/listings" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>Listings</NavLink></li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
    </div>
    )
}

export default MainSidebar;
